module.exports = __webpack_public_path__ + "media/images/design/preview-0eb09f664874816a6e6f6eb2e654b6be.jpg";